export enum ControlTowerTableType {
  ACTIVITIES = 'ACTIVITIES',
  ROUTES = 'ROUTES',
}
